import { render, staticRenderFns } from "./TypoVorschau.vue?vue&type=template&id=32a46ac8&scoped=true"
import script from "./TypoVorschau.vue?vue&type=script&lang=js"
export * from "./TypoVorschau.vue?vue&type=script&lang=js"
import style0 from "./TypoVorschau.vue?vue&type=style&index=0&id=32a46ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a46ac8",
  null
  
)

export default component.exports